import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { FieldChangeListTestIds } from '../StepPendingToolCall.constants';

import { labelStyles, listStyles, rowStyles, valueStyles } from './FieldChangeList.styles';

const FieldChangeList = ({ fieldChanges }) => (
  <Box data-testid={FieldChangeListTestIds.CONTAINER} sx={listStyles}>
    {fieldChanges.map(({ key, label, value }) => (
      <Box data-testid={FieldChangeListTestIds.ROW} key={key} sx={rowStyles}>
        <Typography data-testid={FieldChangeListTestIds.LABEL} sx={labelStyles} variant="medium12">
          {label}
        </Typography>
        <Typography data-testid={FieldChangeListTestIds.VALUE} sx={valueStyles} variant="regular12">
          {value}
        </Typography>
      </Box>
    ))}
  </Box>
);

FieldChangeList.propTypes = {
  fieldChanges: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default memo(FieldChangeList);
